import { Injectable } from "@angular/core";
import { EditCardDialogComponent } from "./edit-card-dialog.component";
import { MatDialogRef, MatDialog } from "@angular/material/dialog";
import { APSMaster } from "src/app/models";
@Injectable({
  providedIn: "root"
})
export class EditCardDialogService
{
  constructor(public dialog: MatDialog) { }
  public openDialog(card: APSMaster): MatDialogRef<EditCardDialogComponent>
  {
    const dialogRef = this.dialog.open(EditCardDialogComponent, {
      width: "400px",
      maxWidth: "90%",
      data: card,
      disableClose: true
    });
    return dialogRef;
  }
}